import type { DealerBilling } from '@jci/core/db/schemas/main.schema';

export const canViewServicePlans = (dealerBilling?: DealerBilling) =>
  dealerBilling?.approvedCountry !== 'IT';
